module.exports = __webpack_public_path__ + "static/media/icon_operating.6850d919.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_operating.png
// module id = 656
// module chunks = 0 1